import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "card-theme",
  class: "p-6 flex flex-col gap-6 w-full md:px-14"
}
const _hoisted_2 = { class: "bg-white p-6 rounded-lg shadow-md" }
const _hoisted_3 = {
  key: 1,
  id: "card-theme-content",
  class: "flex flex-col gap-6"
}
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "text-xl font-semibold" }
const _hoisted_6 = { class: "text-gray-500" }
const _hoisted_7 = {
  id: "logo-preview",
  class: "flex flex-col gap-3"
}
const _hoisted_8 = { class: "text-lg font-medium" }
const _hoisted_9 = { class: "flex justify-center items-center h-24 bg-gray-100 rounded-md" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  id: "partners-preview",
  class: "mb-5"
}
const _hoisted_12 = { class: "font-bold text-lg mb-2" }
const _hoisted_13 = {
  key: 0,
  class: "flex flex-wrap justify-center items-center min-h-[150px] bg-gray-100 rounded-md gap-5"
}
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = {
  key: 1,
  class: "flex flex-wrap justify-center items-center min-h-[150px] bg-gray-100 rounded-md gap-5"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "flex flex-col gap-3" }
const _hoisted_18 = { class: "text-lg font-medium" }
const _hoisted_19 = { class: "flex flex-col gap-3" }
const _hoisted_20 = { class: "text-lg font-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Logo = _resolveComponent("Logo")!
  const _component_PreviewColors = _resolveComponent("PreviewColors")!

  return (_ctx.storeTheme.files.subdomain === _ctx.subdomain)
    ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Loader, {
                key: 0,
                loader: _ctx.loading,
                loaderSize: "h-96"
              }, null, 8, ["loader"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("header", _hoisted_4, [
                  _createElementVNode("h2", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_ctx.$t("theme.org.title")) + " - " + _toDisplayString(_ctx.$t("theme.org.subdomain")) + " ", 1),
                    _createElementVNode("span", _hoisted_6, " (" + _toDisplayString(_ctx.storeTheme.files.subdomain ?? _ctx.subdomain) + ") ", 1)
                  ]),
                  (_ctx.storeTheme.files.subdomain)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        label: _ctx.$t('theme.org.action'),
                        icon: "pi pi-pencil",
                        class: "btn-primary",
                        onClick: _withModifiers(_ctx.goTo, ["prevent"])
                      }, null, 8, ["label", "onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("section", _hoisted_7, [
                  _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t("theme.org.logo")), 1),
                  _createElementVNode("div", _hoisted_9, [
                    (_ctx.logo.length === 0)
                      ? (_openBlock(), _createBlock(_component_Logo, { key: 0 }))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.getFileUrl(_ctx.logo[0]?.image!),
                          alt: "logo",
                          class: "h-20 object-contain",
                          loading: "lazy"
                        }, null, 8, _hoisted_10))
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("theme.org.partners")), 1),
                  (_ctx.partners.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (img, index) => {
                          return (_openBlock(), _createElementBlock("img", {
                            key: index,
                            src: img,
                            alt: img,
                            class: "w-fit h-8 invert",
                            loading: "lazy"
                          }, null, 8, _hoisted_14))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (src, index) => {
                          return (_openBlock(), _createElementBlock("img", {
                            id: "partners-imgs",
                            key: index,
                            src: _ctx.getFileUrl(src.image!),
                            class: "mx-2 w-fit h-10 invert",
                            loading: "lazy"
                          }, null, 8, _hoisted_16))
                        }), 128))
                      ]))
                ]),
                _createElementVNode("section", _hoisted_17, [
                  _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.$t("theme.org.primary")), 1),
                  _createVNode(_component_PreviewColors, {
                    color: _ctx.colors?.primary
                  }, null, 8, ["color"])
                ]),
                _createElementVNode("section", _hoisted_19, [
                  _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.$t("theme.org.secondary")), 1),
                  _createVNode(_component_PreviewColors, {
                    color: _ctx.colors?.secondary
                  }, null, 8, ["color"])
                ])
              ]))
        ])
      ]))
    : _createCommentVNode("", true)
}